module.exports = __webpack_public_path__ + "img/bianzu_hk.3ca091b1.png";